import { globals } from '@/src/globals'
import I_faqData from '@/src/interfaces/I_faqData'

/**
 * Manages the real time searching in the FAQ list
 * @param searchElement Input text element for filtering
 * @param faqListWrapper Wrapper of the FAQs
 */
export const faqSearchFilter = (searchElement: HTMLInputElement, faqListWrapper: HTMLElement): void => {
  // Load global data for DOM-less filtering
  const faqData = globals.externalInput.faqData

  // Kill the script if any of the needed inputs is missing
  if (!faqData || !searchElement || !faqListWrapper) { return }

  // Pre-select all FAQ elements
  const faqList = faqListWrapper.querySelectorAll('.js-faqList-searchSingle') as unknown as HTMLElement[]

  // React to typing in the input
  searchElement.addEventListener('input', (e) => {
    if (e && e.target) {
      const inputElement = e.target as HTMLInputElement
      const inputValue = inputElement.value.toLowerCase()

      // Filter
      filterFaq(inputValue)
    }
  })

  // Filter the actual list
  const filterFaq = (input:string): void => {
    let elementsToShow: I_faqData[] = []
    let elementsToHide: I_faqData[] = []

    // In case non empty input, filter
    if (input.length !== 0) {
      faqData.forEach(single => {
        if (single.title.includes(input) || single.content.includes(input)) {
          elementsToShow.push(single)
        } else {
          elementsToHide.push(single)
        }
      })
    } else {
      // In case of empty input, show everything
      elementsToShow = faqData
    }

    // Hide all needed elements
    elementsToHide.forEach(single => {
      const DOMid = single.id
      faqList[DOMid].style.display = 'none'
    })

    // Show all needed elements
    elementsToShow.forEach((single, key, arr) => {
      const DOMid = single.id
      faqList[DOMid].style.display = 'block'
      faqList[DOMid].classList.remove('-isLast')
      if (key === arr.length - 1) {
        faqList[DOMid].classList.add('-isLast')
      }
    })
  }
}

/**
 * Handles the opening and closing of the FAQ list items
 * @param faqListWrapper Wrapper element for the whole FAQ list
 */
export const faqListControls = (faqListWrapper: HTMLElement): void => {
  const itemList = faqListWrapper.querySelectorAll('.js-faqList-searchSingle-control') as unknown as HTMLElement[]

  const fullLineTriggerList = faqListWrapper.querySelectorAll('.js-faqList-searchSingle-controlFull') as unknown as HTMLElement[]

  const triggerFunction = (single) => {
    const wrapper = single.closest('.js-faqList-searchSingle') as unknown as HTMLElement

    // If the element is animating, kill the script and wait
    if (wrapper.classList.contains('-animating')) {
      return
    }

    // Add animation lock
    wrapper.classList.add('-animating')

    // Do a basing selection and set current max height for smooth animation
    const contentWrapper = wrapper.querySelector('.js-searchSingle-contentWrapper') as unknown as HTMLElement
    const content = wrapper.querySelector('.js-searchSingle-content') as unknown as HTMLElement
    const contentHeight = content.clientHeight
    contentWrapper.style.maxHeight = `${contentHeight}px`

    // Opening & Closing
    if (wrapper.classList.contains('-closed')) {
      // Open
      wrapper.classList.remove('-elipsis')

      // Wait before animation to avoid glitching and let DOM update first
      setTimeout(() => {
        const contentHeight = content.clientHeight
        contentWrapper.style.maxHeight = `${contentHeight}px`
        // Wait for animation
        setTimeout(() => {
          wrapper.classList.remove('-closed')
          contentWrapper.style.removeProperty('max-height')
          wrapper.classList.remove('-animating')
        }, 300)
      }, 50)
    } else {
      // Close
      const contentWrapper = wrapper.querySelector('.js-searchSingle-contentWrapper') as unknown as HTMLElement

      // Wait before animation to avoid glitching and let DOM update first
      setTimeout(() => {
        contentWrapper.style.maxHeight = (window.innerWidth > 991) ? '35px' : '35px'

        // Wait for animation
        setTimeout(() => {
          wrapper.classList.add('-closed')
          wrapper.classList.add('-elipsis')
          wrapper.classList.remove('-animating')
        }, 250)
      }, 50)
    }
  }

  itemList.forEach(single => {
    single.addEventListener('click', () => {
      triggerFunction(single)
    })
  })

  fullLineTriggerList.forEach(single => {
    single.addEventListener('click', () => {
      triggerFunction(single)
    })
  })
}
